import React, { useEffect } from "react";

import Main from '../components/SupportAndFaq/Main'
import Faq from "../components/SupportAndFaq/Faq";
import WeValue from "../components/SupportAndFaq/WeValue";
import YourTradingJourney from "../components/Home/YourTradingJourney";

function SupportAndFaq () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">  
            <Main/>
            <Faq/>
            <WeValue/>
            <YourTradingJourney/>
        </div>
    );
}

export default SupportAndFaq;